import { createAction, props } from '@ngrx/store';
import { Plant } from 'src/app/model/device-vct/device-vct-implant';
import { CreateInvitationVct, InvitationVct, MassiveVctInvitationsPlant } from 'src/app/model/device-vct/device-vct-invitations';
import { Site } from 'src/app/model/site';

/* VCT LIST */
export const getSitesVctList = createAction('GET_SITES_VCT_LIST_BY_SITE');
export const getSitesVctListSuccess = createAction('GET_SITES_VCT_LIST_BY_SITE_SUCCESS',
	props<{ sitesList: Site[] }>());
export const getSitesVctListListFailed = createAction('GET_SITES_VCT_LIST_BY_SITE_FAILED', props<{ errorMessage: string }>());

/** DEVICE LIST */
export const getDevicesVctList = createAction('GET_DEVICE_VCT_LIST_BY_SITE');
export const getDevicesVctListSuccess = createAction('GET_DEVICE_VCT_LIST_BY_SITE_SUCCESS',
	props<{ plantsList: Plant[] }>());
export const getDevicesVctListFailed = createAction('GET_DEVICE_VCT_LIST_BY_SITE_FAILED', props<{ errorMessage: string }>());

/* VCT INVITATIONS */
export const getVctInvitations = createAction('GET_VCT_INVITATIONS');
export const getVctInvitationsSuccess = createAction('GET_VCT_INVITATIONS_SUCCESS',
	props<{ invitationsList: InvitationVct[] }>());
export const getVctInvitationsFailed = createAction('GET_VCT_INVITATIONS_FAILED', props<{ errorMessage: string }>());

/* CREATE VCT INVITATIONS */
export const createVctInvitationsReset = createAction('CREATE_VCT_INVITATIONS_RESET');
export const createVctInvitations = createAction('CREATE_VCT_INVITATIONS', props<{ invitation: CreateInvitationVct, cleanup: boolean, accept: boolean, }>());
export const createVctInvitationsSuccess = createAction('CREATE_VCT_INVITATIONS_SUCCESS', props<{ message: string }>());
export const createVctInvitationsFailed = createAction('CREATE_VCT_INVITATIONS_FAILED', props<{ errorMessage: string }>());

/* REMOVE VCT INVITATIONS */
export const removeVctInvitations = createAction('REMOVE_VCT_INVITATIONS', props<{ invitationId: string }>());
export const removeVctInvitationsSuccess = createAction('REMOVE_VCT_INVITATIONS_SUCCESS', props<{ message: string }>());
export const removeVctInvitationsFailed = createAction('REMOVE_VCT_INVITATIONS_FAILED', props<{ errorMessage: string }>());

/* EDIT VCT MODULE NAME */
export const editVctModuleNameReset = createAction('RESET_VCT_INVITATIONS_RESET');
export const editVctModuleName = createAction('EDIT_VCT_MODULE_NAME', props<{ moduleId: number, aliasName: string }>());
export const editVctModuleNameSuccess = createAction('EDIT_VCT_MODULE_NAME_SUCCESS', props<{ message: string }>());
export const editVctModuleNameFailed = createAction('EDIT_VCT_MODULE_NAME_FAILED', props<{ errorMessage: string }>());

/* EDIT VCT FEATURE NAME */
export const editVctFeatureNameReset = createAction('RESET_VCT_INVITATIONS_RESET');
export const editVctFeatureName = createAction('EDIT_VCT_FEATURE_NAME', props<{ featureId: number, aliasName: string }>());
export const editVctFeatureNameSuccess = createAction('EDIT_VCT_FEATURE_NAME_SUCCESS', props<{ message: string }>());
export const editVctFeatureNameFailed = createAction('EDIT_VCT_FEATURE_NAME_FAILED', props<{ errorMessage: string }>());

/* ENABLE VCT AUX */
export const enableVctAux = createAction('ENABLE_VCT_AUX', props<{ moduleId: number, auxId: number }>());
export const enableVctAuxSuccess = createAction('ENABLE_VCT_AUX_SUCCESS', props<{ message: string, moduleId: number, auxId: number }>());
export const enableVctAuxFailed = createAction('ENABLE_VCT_AUX_FAILED', props<{ errorMessage: string, moduleId: number, auxId: number }>());

/* EDIT VCT AUX */
export const editVctAux = createAction('EDIT_VCT_AUX', props<{ moduleId: number, auxId: number, icon: string }>());
export const editVctAuxSuccess = createAction('EDIT_VCT_AUX_SUCCESS', props<{ message: string }>());
export const editVctAuxFailed = createAction('EDIT_VCT_AUX_FAILED', props<{ errorMessage: string }>());

/* DISABLE VCT AUX */
export const disableVctAux = createAction('DISABLE_VCT_AUX', props<{ moduleId: number, auxId: number }>());
export const disableVctAuxSuccess = createAction('DISABLE_VCT_AUX_SUCCESS', props<{ message: string, moduleId: number, auxId: number }>());
export const disableVctAuxFailed = createAction('DISABLE_VCT_AUX_FAILED', props<{ errorMessage: string, moduleId: number, auxId: number }>());

/* ENABLE EDIT SYSTEM */
export const enableEditSystem = createAction('ENABLE_EDIT_SYSTEM', props<{ editSystem: boolean }>());

/* RESET VCT INVITATION APP */
export const resetVctInvitationApp = createAction('RESET_VCT_INVITATION_APP', props<{ featureId: number }>());
export const resetVctInvitationAppSuccess = createAction('RESET_VCT_INVITATION_APP_SUCCESS', props<{ message: string }>());
export const resetVctInvitationAppFailed = createAction('RESET_VCT_INVITATION_APP_FAILED', props<{ errorMessage: string }>());

/* ABANDON VCT PLANT */
export const abandonVctPlant = createAction('ABANDON_VCT_PLANT', props<{ plantId: number, cleanup: boolean }>());
export const abandonVctPlantSuccess = createAction('ABANDON_VCT_PLANT_SUCCESS', props<{ message: string }>());
export const abandonVctPlantFailed = createAction('ABANDON_VCT_PLANT_FAILED', props<{ errorMessage: string }>());

/* ABANDON VCT MODULE */
export const abandonVctModule = createAction('ABANDON_VCT_MODULE', props<{ moduleId: number, abandon: boolean }>());
export const abandonVctModuleSuccess = createAction('ABANDON_VCT_MODULE_SUCCESS', props<{ message: string }>());
export const abandonVctModuleFailed = createAction('ABANDON_VCT_MODULE_FAILED', props<{ errorMessage: string }>());

/* ABANDON VCT FEATURE */
export const abandonVctFeature = createAction('ABANDON_VCT_FEATURE', props<{ featureId: number, abandon: boolean }>());
export const abandonVctFeatureSuccess = createAction('ABANDON_VCT_FEATURE_SUCCESS', props<{ message: string }>());
export const abandonVctFeatureFailed = createAction('ABANDON_VCT_FEATURE_FAILED', props<{ errorMessage: string }>());

/* MASSIVE VCT INVITATIONS */
export const massiveVctInvitationsReset = createAction('MASSIVE_VCT_INVITATIONS_RESET');
export const massiveVctInvitations = createAction('MASSIVE_VCT_INVITATIONS', props<{ plantId: number, plant: MassiveVctInvitationsPlant }>());
export const massiveVctInvitationsSuccess = createAction('MASSIVE_VCT_INVITATIONS_SUCCESS', props<{ message: string }>());
export const massiveVctInvitationsFailed = createAction('MASSIVE_VCT_INVITATIONS_FAILED', props<{ errorMessage: string }>());